/**
 * The legal links in the footer of every view of the public onboarding page. One place for them; the
 * trailing slash matters (without it the server redirects to http). Not /datenschutz or /imprint:
 * those only return the start page.
 */
export const LEGAL_LINKS = {
  imprint: "https://www.the-real-insight.ai/impressum/",
  privacy: "https://www.the-real-insight.ai/privacy/",
} as const;

export const COMPANY_NAME = "The Real Insight GmbH";
